import moment from 'moment-timezone';

import { action } from '@ember/object';
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

type DateValue = string;
type DateValues = DateValue[];

interface IArgs {
  values: DateValues;
  definition: TFilterDefinition;
  comparator: TComparator;
  onChange?: (values: DateValues) => void;
}

export default class DateFilter extends Component<IArgs> {
  @tracked leftValue?: string;
  @tracked rightValue?: string;

  get values() {
    return [this.leftValue, this.rightValue].filter((v) => typeof v !== 'undefined') as string[];
  }

  constructor(owner: any, args: IArgs) {
    super(owner, args);
    const { values } = this.args;
    if (values.length > 1) {
      this.leftValue = values[0];
      this.rightValue = values[1];
    } else if (values.length === 1) {
      this.leftValue = values[0];
    }
  }

  @action
  valueDidChange(newValue?: Date) {
    this.leftValue = this.formatValue(newValue);
    this.args.onChange?.(this.leftValue ? [this.leftValue] : []);
  }

  @action
  valueLeftDidChange(leftValue?: Date) {
    if (isPresent(leftValue)) {
      this.leftValue = this.formatValue(leftValue) as DateValue;
      if (this.leftValue && this.rightValue) {
        this.args.onChange?.(this.values);
      }
    }
  }

  @action
  valueRightDidChange(newValue?: Date) {
    if (isPresent(newValue)) {
      this.rightValue = this.formatValue(newValue) as DateValue;
      if (this.leftValue && this.rightValue) {
        this.args.onChange?.(this.values);
      }
    }
  }

  private formatValue(value?: Date) {
    return isPresent(value) ? moment(new Date(value as Date)).format('YYYY-MM-DD') : undefined;
  }
}
